import { createFeatureSelector } from '@ngrx/store';

import { hotelResultsFeatureName, HotelResultsModuleState } from '@hotels/hotel-results/store/state/hotel-results-module.state';

export const hotelResultsRootSelector = createFeatureSelector<HotelResultsModuleState>(hotelResultsFeatureName);
